import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=3d8f2adb&scoped=true"
import script from "./AppLoader.vue?vue&type=script&lang=js"
export * from "./AppLoader.vue?vue&type=script&lang=js"
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=3d8f2adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8f2adb",
  null
  
)

export default component.exports